import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import modalActions from '@mm/state/modules/modalsState/actions';

const confirmationText =
  'Turning on this catch-all comment guard will turn off the current catch-all comment guard';
const confirmationTitle = 'Turn off the current catch-all comment guard?';

export const useCatchAllConfirmModal = (
  header = confirmationTitle,
  message = confirmationText,
) => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return (onOk: (ok?: boolean) => void) => {
    const onCloseHandler = (ok: boolean) => {
      if (ok) {
        onOk(ok);
      }
    };

    dispatch(
      modalActions.openGeneralConfirmModal({
        messageText: message,
        headerText: header,
        onCloseHandler,
        okButtonStyling: {
          blue: true,
        },
      }),
    );
  };
};
